import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useRegisterData } from './SignupStepper';
import { Box, FormControl, Input, InputLabel } from '@mui/material';
import { apiUser } from '../../basedata/apiCall';
import { BASE } from '../../basedata/constants';
import { FaCheck } from "react-icons/fa";


import validator from 'validator';
import { useStep } from '../../context/StepContext'

interface FormStepperInterface {
  onBack: () => void;
}

const CheckIcon = FaCheck as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const SignupPartTwo = ({ onBack}:FormStepperInterface) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setStep } = useStep();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [formData, setFormData] = useState({
        phone: '',
        gender: '',
        email: ''
    });

  const {handleRegisterFormData} = useRegisterData()

  const {
    register,
    handleSubmit,
    setError,
    reset,
    getValues,
    setValue,
    watch,
    formState: { errors },
    clearErrors
  } = useForm()

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isMinor, setIsMinor] = useState(true);

    const isFormValid = watch('phone') && watch('email')

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { id, value } = e.target
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }))

        // setErrors((prevErrors) => ({
        //     ...prevErrors,
        //     [id]: value ? '' : t('signup.errors.required'),
        // }))
    }

    // const formSubmitter = (data:any) => {

    //   console.log('piutaria')
    //   console.log(data)
    //   return false
      
    // };

    const formSubmitter = async (data:any) => {
      

      const sessionOne = sessionStorage.getItem("heartPartOne");
      const partOneData = sessionOne ?JSON.parse(sessionOne) : {};
      const fullData = { ...partOneData, ...data };


     if (!data.phone || data.phone.replace(/\D/g, '').length < 10) {
        setError('phone', {
          type: 'manual',
          message: t('signup.errors.phone'),
        });
        return;
      }

      if (!data.email || !validator.isEmail(data.email)) {
        setError('email', {
          type: 'manual',
          message: t('signup.errors.email'),
        });
        return;
      }

        const properName = fullData.name.replace(/^\s+|\s+$/g, '').split(' ')
        const dateFormate = fullData.birthdate.split('/')

        const _user_register = await apiUser.post('/user',{
          firstName: properName.shift(),
          externalId: `${fullData.document.replace(/^\s+|\s+$/g, '')}_${Math.floor(Math.random() * 291)}`,
          lastName: properName.join(' '),
          gender: '',
          document: fullData.document.replace(/^\s+|\s+$/g, ''),
          document_type: '',
          email: fullData.email.replace(/^\s+|\s+$/g, ''),
          phoneNumber: fullData.phone
            .replace(/"/g, '')
            .replace(/'/g, '')
            .replace(/\(|\)/g, ''),
          birthDate:
            dateFormate[2] + '-' + dateFormate[1] + '-' + dateFormate[0],
          nationality: '',
          originCompanyId: BASE.company.id,
          function: fullData.parent_name || '',
          sector: fullData.parent_document || '',
        })

        const _data = _user_register?.data
        sessionStorage.setItem('token', _data?.sup)

        window.location.href = `/validating?token=${_data.sup}`
        return false
        
        // const newErrors = {
        //     phone: formData.phone ? '' : t('signup.errors.required'),
        //     date: formData.birthdate ? '' : t('signup.errors.required'),
        //     email: formData.email ? '' : t('signup.errors.required'),
        //     // gender: formData.gender && formData.gender !== 'start' ? '' : t('signup.errors.required'),
        // }

        // data.gogo = 'rola'
        // handleRegisterFormData(data)
        // const hasErrors = Object.values(newErrors).some((error) => error)
        // if (!hasErrors) {
        //     // const savedData = localStorage.getItem("signupPartOne");
        //     // const partOneData = savedData ?JSON.parse(savedData) : {};
        //     // const fullData = { ...partOneData, ...formData };

        //     console.log(fullData);

        //     localStorage.setItem("signupComplete", JSON.stringify(fullData));

        //     navigate("/mobile-handler");
        // }
    }

    // const onNext = () => {
    //   window.location.href = '/mobile-handler'
    // }
    useEffect(() => {
      setStep(1);
      const sessionOne = sessionStorage.getItem("heartPartOne");
      const partOneData = sessionOne ?JSON.parse(sessionOne) : {};

      if (partOneData.birthdate) {
        const [day, month, year] = partOneData.birthdate.split('/').map(Number);
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
        }

        if (age > 16) {
          setIsMinor(false)
        }else{
          setIsMinor(true)
        }
      }

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


   const validationCheck = (domEvent: any, domField: string) => {
    const e = domEvent?.target?.value?.trim?.() || '';

    clearErrors(domField);

    const phone = domField === 'phone'
      ? e.replace(/\D/g, '')
      : getValues('phone')?.replace(/\D/g, '');

    const email = domField === 'email'
      ? e
      : getValues('email')?.trim();

    if (domField === 'phone') {
      if (phone === '') {
        setTermsAccepted(false);
        return;
      }
      if (phone.length < 10) {
        setTermsAccepted(false);
        setError('phone', {
          type: 'manual',
          message: t('signup.errors.phone'),
        });
        return;
      }
      if (!email || !validator.isEmail(email)) {
        setTermsAccepted(false);
        return;
      }
    }

    if (domField === 'email') {
      if (email === '') {
        setTermsAccepted(false);
        return;
      }
      if (!validator.isEmail(email)) {
        setTermsAccepted(false);
        setError('email', {
          type: 'manual',
          message: t('signup.errors.email'),
        });
        return;
      }
      if (!phone || phone.length < 10) {
        setTermsAccepted(false);
        return;
      }
    }

    setTermsAccepted(true);
  };


    const [accepted, setAccepted] = useState(false);
    const [minorCheck, setMinorCheck] = useState(false);
    const parentName = watch('parent_name');
    const parentDoc = watch('parent_document');
    const acceptedWatch = watch('accepted'); 

    const validateAllFields = () => {
      const phone = getValues('phone')?.trim();
      const email = getValues('email')?.trim();
      const parentName = getValues('parent_name')?.trim();
      const parentDoc = getValues('parent_document')?.trim();
      if (phone && email) {
        setTermsAccepted(true);
      } else {
        setTermsAccepted(false);
      }
      if (parentName && parentDoc && accepted) {
        setMinorCheck(true);
      } else {
        setMinorCheck(false);
      }
    };


   useEffect(() => {
    validateAllFields();
  }, [
    watch('phone'),
    watch('email'),
    watch('parent_name'),
    watch('parent_document'),
    accepted,
  ]);

  useEffect(() => {
  const isValid =
    parentName?.trim() &&
    parentDoc?.trim() &&
    accepted;

  setMinorCheck(!!isValid);
}, [parentName, parentDoc, accepted]);



    const handleMinorSubmit = () => {
      const parentName = getValues('parent_name')?.trim();
      const parentDocument = getValues('parent_document')?.trim();

      let hasError = false;

      if (!parentName) {
        setError('parent_name', {
          type: 'manual',
          message: t('signup.errors.parent_name'),
        });
        hasError = true;
      }

      if (!parentDocument) {
        setError('parent_document', {
          type: 'manual',
          message: t('signup.errors.parent_document'),
        });
        hasError = true;
      }

      if (hasError) {
        setAccepted(false);
        return;
      }

      if (accepted) {
        setIsMinor(false);
      }
    };
    
      const handleAcceptTerms = () => {
        const newAccepted = !accepted;
        setAccepted(newAccepted);

        const name = getValues('parent_name')?.trim();
        const doc = getValues('parent_document')?.trim();

        const isValid =
          name &&
          doc &&
          !errors.parent_name &&
          !errors.parent_document &&
          newAccepted;

        setMinorCheck(!!isValid);
      };

    

    return (
      <>
        <form className="signup-form bepass-form" onSubmit={handleSubmit(formSubmitter)} noValidate>
          {isMinor ? (
          <Box>
            <h1 className="bepass-title">{t('signup.messages.minor_message_title')}</h1>
            <p className='bepass-text-default'>
                {t('signup.messages.minor_message')}
            </p>
           <div className="input-wrapper">
              <label
                htmlFor="parent_name"
                className={`embedded-label ${errors.parent_name ? 'erro' : ''}`}
              >
                {t('signup.labels.parent_name')}
              </label>
              <input
                id="parent_name"
                type="text"
                {...register('parent_name')}
                placeholder={t('signup.placeholders.parent_name')}
                onChange={(e) => {
                  clearErrors('parent_name');
                  setValue('parent_name', e.target.value);
                }}
                className={`embedded-input ${errors.parent_name ? 'erro' : ''}`}
              />
              {errors.parent_name && (
                <span className="label-error">
                  {t('signup.errors.parent_name')}
                </span>
              )}
            </div>

            <div className="input-wrapper">
              <label
                htmlFor="parent_document"
                className={`embedded-label ${errors.parent_document ? 'erro' : ''}`}
              >
                {t('signup.labels.parent_document')}
              </label>
              <input
                id="parent_document"
                type="text"
                {...register('parent_document')}
                placeholder={t('signup.placeholders.parent_document')}
                onChange={(e) => {
                  clearErrors('parent_document');
                  setValue('parent_document', e.target.value);
                }}
                className={`embedded-input ${errors.parent_document ? 'erro' : ''}`}
              />
              {errors.parent_document && (
                <span className="label-error">
                  {t('signup.errors.parent_document')}
                </span>
              )}
            </div>

          <div className="terms-container">
            <label htmlFor="accept-terms" className="checkbox-label">
              <input
                  type="checkbox"
                  id="accept-terms"
                  checked={accepted}
                  onChange={(e) => {
                    const newAccepted = e.target.checked;
                    setAccepted(newAccepted);
                    const name = getValues('parent_name')?.trim();
                    const doc = getValues('parent_document')?.trim();

                    const isValid =
                      name &&
                      doc &&
                      !errors.parent_name &&
                      !errors.parent_document &&
                      newAccepted;

                    setMinorCheck(!!isValid);
                  }}
                />
              <span className={`custom-check ${accepted ? 'checked' : ''}`}>
                {accepted && <CheckIcon className="check-icon"/>}
              </span>

              <span className="terms-text">
                {t("signup.messages.minor_confirm_message_start")}{" "}
                <a
                  href="https://storage.googleapis.com/companies-assets/bepass/termo_consentimento.pdf"
                  rel="noreferrer noopener"
                  target="_blank"
                  className="bold-link"
                >
                  {t("signup.messages.minor_confirm_message_highlight")}
                </a>{" "}
                {t("signup.messages.minor_confirm_message_end")}
              </span>
            </label>
          </div>
           <button 
            type="button" 
            className="continue-button" 
            onClick={handleMinorSubmit}
            disabled={!minorCheck}
          >
            {t('signup.buttons.finish')}
          </button>
          </Box>
          ):(
          <Box>
            <h1 className='bepass-text-title-partOne'>{t('signup.labels.contact')}</h1>
            <p className='bepass-text-default'>
                {t('signup.messages.register_follow-message')}
            </p>
            <div className="input-wrapper">
              <label htmlFor="phone" className={`embedded-label ${errors.phone ? 'erro' : ''}`}>
                {t('signup.labels.phone')}
              </label>
             <input
                id="phone"
                type="text"
                {...register('phone')}
                placeholder={t('signup.placeholders.phone')}
                value={formData.phone}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\D/g, '').slice(0, 11); 
                  let masked = raw;

                  if (raw.length > 2 && raw.length <= 6) {
                    masked = `(${raw.slice(0, 2)}) ${raw.slice(2)}`;
                  } else if (raw.length > 6 && raw.length <= 10) {
                    masked = `(${raw.slice(0, 2)}) ${raw.slice(2, 6)}-${raw.slice(6)}`;
                  } else if (raw.length > 10) {
                    masked = `(${raw.slice(0, 2)}) ${raw.slice(2, 7)}-${raw.slice(7, 11)}`;
                  }

                  setFormData((prev) => ({
                    ...prev,
                    phone: masked,
                  }));

                  setValue('phone', masked);
                  if (raw.length >= 10) {
                    clearErrors('phone');
                  }
                }}
                className={`embedded-input ${errors.phone ? 'erro' : ''}`}
              />

                {errors.phone && (
                  <span className="label-error">
                    {t('signup.errors.phone')}
                  </span>
                )}
              </div>
              <div className="input-wrapper">
                <label htmlFor="email" className={`embedded-label ${errors.email ? 'erro' : ''}`}>
                  {t('signup.labels.email')}
                </label>
                <input
                  id="email"
                  type="email"
                  {...register('email')}
                  value={formData.email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      email: value,
                    }));
                    setValue('email', value);

                    if (validator.isEmail(value)) {
                      clearErrors('email');
                    }
                  }}
                  placeholder={t('signup.placeholders.email')}
                  className={`embedded-input ${errors.email ? 'erro' : ''}`}
                />
                {errors.email && (
                  <span className="label-error">
                    {t('signup.errors.email')}
                  </span>
                )}
              </div>

            <button 
                  type="submit" 
                  className="continue-button" 
                  // onClick={onNext}
                  disabled={!termsAccepted}
              >
                  {t('signup.buttons.finish')}
            </button>
            </Box>
          )}
            <div className="back-button" onClick={onBack}>
                <div className="icon-container">
                    <ArrowBackIcon className="arrow-icon" />
                </div>
                <span className="text">{t('signup.navigation.back_text')}</span>
            </div>
        </form>
      </>
    );
};

export default SignupPartTwo